import { collection, doc, getDoc, getDocs, setDoc, deleteDoc, getDocsFromCache } from 'firebase/firestore';
import { db } from '../../firebase';
import { Project } from "./project"
import { Zone } from "./zone"
import { Chemical } from "./chemical"
import { Action } from "./action"
import { Type } from "./type"
import { Weed } from "./weed"

function docMap(doc) {
	return { id: doc.id, ...doc.data() };
}

function genLocalStorageName(docname)
{
	return "cacheTimestamp-"+docname;
}

export async function getCollection(docName, docMaper) {
	if(!docMaper)
	{docMaper=docMap}
	const ref = collection(db, docName);
	
	const ot = parseInt(localStorage.getItem(genLocalStorageName(docName)));
	const nt = (new Date()).getTime();
	let snapshot;

	if(nt-ot < 2.5*1000*60)
	{
		snapshot = await getDocsFromCache(ref);
	}else{
		snapshot = await getDocs(ref);
		localStorage.setItem(genLocalStorageName(docName),nt);
	}
	console.log(snapshot.metadata.fromCache ? "from local cache" : "from server");
	const docs = snapshot.docs.map(docMaper);
	return docs;
}

export async function getAllProjects() {
	return await Project.getAll();
}

export async function getAllZones() {
	return await Zone.getAll();
}

export async function getAllActivities() {
	return await getCollection("Activity");
}

export async function getAllAdmins() {
	const ref = collection(db, "Admin");
	const snapshot = await getDocs(ref);
	const docs = snapshot.docs.map((doc) => {
		const { adminId } = doc.data();
		return adminId;
	});
	return docs;
}

export async function getAllChemicals()
{
	return await Chemical.getAll();
}

export async function getAllActions()
{
	return await Action.getAll();
}

export async function getAllTypes()
{
	return await Type.getAll();
}

export async function getAllWeeds()
{
	return await Weed.getAll();
}